import { inject, observer } from "mobx-react";
import { Link as RouterLink } from "react-router-dom";

import { analyticeEvent } from "utils/Utils";
import { useEffect } from "react";
import { MenuConfigs, MenuConfig } from "views/setting/constants/menuConfig";
const Link = RouterLink as any;

// 메뉴 아이템 컴포넌트
const MenuList = ({
  configs,
  activeMenu,
  onMenuClick,
}: {
  configs: MenuConfig[];
  activeMenu: string;
  onMenuClick: (config: MenuConfig) => void;
}) => {
  return (
    <>
      {configs.map(config => (
        <li className={activeMenu === config.key ? "on" : ""} onClick={() => onMenuClick(config)} key={config.key}>
          <Link to={config.link}>{config.label}</Link>
        </li>
      ))}
    </>
  );
};

// 레이아웃 컴포넌트
const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="section_menu">
      <h2>설정</h2>
      <ul className="list_menu">{children}</ul>
    </div>
  );
};
const SettingDefaultLeftView = ({ rootStore }: { rootStore: any }) => {
  const { settingStore, searchStore } = rootStore;
  const { getMainPosType, getSettingUseMenu } = settingStore;

  useEffect(() => {
    settingStore.setSettingView(false);
  }, [settingStore]);

  // 메뉴 클릭 핸들러(메뉴 클릭 시 메뉴 상태 변경 및 이벤트 발생)
  const handleMenuClick = (config: MenuConfig) => {
    settingStore.setSettingUseMenu(config.key);
    analyticeEvent("setting", config.analyticEvent, searchStore.getShopCd);
  };

  // 메인 포스 타입이 아닌 경우 메뉴 필터링
  const getVisibleMenus = () => {
    if (getMainPosType === "N") {
      return MenuConfigs.filter(config => config.showInNonMainPos);
    }
    return MenuConfigs;
  };

  const visibleMenus = getVisibleMenus();

  return (
    <Layout>
      <MenuList configs={visibleMenus} activeMenu={getSettingUseMenu} onMenuClick={handleMenuClick} />
    </Layout>
  );
};

export default inject("rootStore")(observer(SettingDefaultLeftView));
